import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './ProgressBar.style'

type ProgressBarProps = {
  className?: string
  variant?: 'percentage' | 'indeterminate'
} & ComponentProps<'div'>

function ProgressBar(props: ProgressBarProps): ReactElement {
  const { className = '', variant = 'indeterminate', ...rest } = props

  return (
    <div
      className={cn('ProgressBar', className, variant)}
      css={style}
      {...rest}
    >
      <div className="ProgressBar-inner"></div>
    </div>
  )
}

export default ProgressBar
